module.exports = __webpack_public_path__ + "static/media/lounge-pass-background.cbc5c58b.svg";